import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../hooks/useTranslations";
import { ModuleSettings } from "../../../http/types/modules";
import ScrewFamiliesTab from "./admin/ScrewFamiliesTab";
import ScrewsTab from "./admin/ScrewsTab";
import TimberClassesTab from "./admin/TimberClassesTab";

interface BeamReinforcementAdminSettingsProps {
  moduleData: ModuleSettings;
}

const BeamReinforcementAdminSettings: FC<BeamReinforcementAdminSettingsProps> = () => {
  const i18n = useI18n();

  const tabs = [
    { title: i18n.translation.beamReinforcementModule.timbers.plural },
    { title: i18n.translation.beamReinforcementModule.screws.plural },
    { title: i18n.translation.beamReinforcementModule.screwFamilies.plural },
  ];

  return (
    <Tabs renderMode="eager"
      urlParameter="l_tab"
      tabs={tabs}
      contents={[
        <TimberClassesTab />,
        <ScrewsTab />,
        <ScrewFamiliesTab />,
      ]}
    />
  );
};

export default BeamReinforcementAdminSettings;
